import React from 'react';
import { Link } from 'react-router-dom';
import '../styles/Home.css';

const Home = () => {
  return (
    <div className="home-container">
      <section className="hero-section">
        <h2 className="hero-title">
          Vortex Evolution
        </h2>
        <p className="hero-subtitle">
          Plataforma de Inteligencia Naval para preparación de exámenes de ascensos y especialización militar.
        </p>
      </section>

      <section className="features-section">
        <div className="features-grid">
          {/* Flashcards */}
          <div className="card feature-card" style={{ borderTop: '3px solid #c5a059' }}>
            <div className="feature-icon">📇</div>
            <h3>Flashcards</h3>
            <p>Tarjetas de memoria con repetición espaciada y autoevaluación inteligente.</p>
            <Link to="/dashboard/flashcards" className="btn-primary feature-btn">Práctica Memoria</Link>
          </div>

          {/* Mapa de Debilidades */}
          <div className="card feature-card" style={{ borderTop: '3px solid #ef4444' }}>
            <div className="feature-icon">📊</div>
            <h3>Mapa de Debilidades</h3>
            <p>Diagnóstico visual por ley y materia con semáforo 🔴🟡🟢 para enfoque de estudio.</p>
            <Link to="/dashboard/mapa-debilidades" className="btn-primary feature-btn">Ver Semáforo</Link>
          </div>

          {/* Modo Guardia */}
          <div className="card feature-card" style={{ borderTop: '3px solid #c5a059' }}>
            <div className="feature-icon">🛡️</div>
            <h3>Modo Guardia</h3>
            <p>Estudio auditivo pasivo continuo: Pregunta ➔ Pausa de reflexión ➔ Respuesta.</p>
            <Link to="/dashboard/modo-guardia" className="btn-primary feature-btn">Iniciar Guardia</Link>
          </div>

          {/* Cuestionarios */}
          <div className="card feature-card">
            <div className="feature-icon">📝</div>
            <h3>Cuestionarios</h3>
            <p>Evaluación interactiva de conocimientos con retroalimentación en tiempo real.</p>
            <Link to="/dashboard/quiz" className="btn-primary feature-btn">Explorar</Link>
          </div>

          {/* Material */}
          <div className="card feature-card">
            <div className="feature-icon">📖</div>
            <h3>Material</h3>
            <p>Acceso centralizado a manuales, leyes y bibliografía técnica oficial.</p>
            <Link to="/dashboard/material" className="btn-primary feature-btn">Ver Contenido</Link>
          </div>

          {/* IA Vortex */}
          <div className="card feature-card">
            <div className="feature-icon">🤖</div>
            <h3>IA Vortex</h3>
            <p>Análisis de documentos y generación de resúmenes mediante inteligencia artificial.</p>
            <Link to="/dashboard/ia-vortex" className="btn-primary feature-btn">Consultar</Link>
          </div>

          {/* Repositorio de Audio */}
          <div className="card feature-card">
            <div className="feature-icon">🎧</div>
            <h3>Repositorio de Audio</h3>
            <p>Audios estratégicos y bibliografía narrada para estudio en movimiento.</p>
            <Link to="/dashboard/audios" className="btn-primary feature-btn">Escuchar</Link>
          </div>

          {/* Bibliografía */}
          <div className="card feature-card">
            <div className="feature-icon">📚</div>
            <h3>Bibliografía</h3>
            <p>Repositorio normativo y técnico para consulta inmediata.</p>
            <Link to="/dashboard/bibliografia" className="btn-primary feature-btn">Explorar</Link>
          </div>

          {/* Simulador */}
          <div className="card feature-card">
            <div className="feature-icon">🎯</div>
            <h3>Simulador</h3>
            <p>Entorno de evaluación real con cronómetro y ranking de desempeño.</p>
            <Link to="/dashboard/simulador" className="btn-primary feature-btn">Iniciar Test</Link>
          </div>
        </div>
      </section>

      <section className="info-section">
        <div className="card">
          <h2>Sobre Proyecto Vortex</h2>
          <p style={{ textAlign: 'justify', lineHeight: '1.8' }}>
            Vortex Evolution representa el siguiente paso estratégico en la formación naval tecnológica.
            Integrando modelos de lenguaje avanzados y herramientas de accesibilidad, permitimos que el personal
            pueda optimizar sus ciclos de estudio, realizar resúmenes inteligentes y transformar documentos en
            experiencias auditivas de alta fidelidad.
          </p>
        </div>
      </section>

      <section className="social-section">
        <h2 style={{ textAlign: 'center', marginBottom: '30px' }}>Enlaces Estratégicos</h2>
        <div className="social-links">
          <a href="https://facebook.com" target="_blank" rel="noreferrer" className="card social-item">
            <span>📘 Facebook</span>
          </a>
          <a href="https://instagram.com" target="_blank" rel="noreferrer" className="card social-item">
            <span>📷 Instagram</span>
          </a>
          <a href="https://tiktok.com" target="_blank" rel="noreferrer" className="card social-item">
            <span>🎵 TikTok</span>
          </a>
          <a href="https://youtube.com" target="_blank" rel="noreferrer" className="card social-item">
            <span>📺 YouTube</span>
          </a>
        </div>
      </section>

      <footer className="home-footer">
        <p>© {new Date().getFullYear()} VORTEX EVOLUTION - Inteligencia Naval Aplicada.</p>
      </footer>
    </div>
  );
};

export default Home;
